import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage', {
    organisation: 'Organisation',
    title: 'Organisation | {companyName}',
    yourOrganisationHasBeenSaved: 'Your Organisation has been saved.',
    errorMessage: 'Oops, something went wrong. Please try again.',
    enforcementSuccessInfo:
        'The {enforcementType} two-factor authentication enforcement was set. Please note that it may take approximately 2-3 minutes for the feature to become fully functional. During this time, you may experience a temporary delay in TFA enforcement usability.',
});
